import { GalleryScrollIndicatorComponentPropsInterface } from 'common/module/gallery-scroll-indicator/component-props.interface';
import { GalleryScrollIndicatorComponentStateInterface } from 'common/module/gallery-scroll-indicator/component-state.interface';

/**
 * Returns first and last visible indicators indexes
 */
export const galleryScrollIndicatorGetVisibleIndexes = (
  state: GalleryScrollIndicatorComponentPropsInterface & GalleryScrollIndicatorComponentStateInterface
): {
  firstVisibleItemIndex: number;
  lastVisibleItemIndex: number;
} => {
  switch (true) {
    // In case for first item being active
    case state.activeIndex === 0:
      return {
        firstVisibleItemIndex: 0,
        lastVisibleItemIndex: state.visibleItemsCount - 1,
      };
    // In case active item is being the last item
    case state.activeIndex === state.itemsCount - 1:
      return {
        firstVisibleItemIndex: state.activeIndex + 1 - state.visibleItemsCount,
        lastVisibleItemIndex: state.activeIndex,
      };
    // In case of active item is not visible and is on right
    case state.activeIndex <= state.firstVisibleItemIndex:
      return {
        firstVisibleItemIndex: state.activeIndex - 1,
        lastVisibleItemIndex: state.activeIndex + state.visibleItemsCount - 2,
      };
    // In case of active item is not visible and is on left
    case state.activeIndex >= state.lastVisibleItemIndex:
      return {
        firstVisibleItemIndex: state.activeIndex + 2 - state.visibleItemsCount,
        lastVisibleItemIndex: state.activeIndex + 1,
      };
    // Item is in between visible items
    default:
      return {
        firstVisibleItemIndex: state.firstVisibleItemIndex,
        lastVisibleItemIndex: state.lastVisibleItemIndex,
      };
  }
};
